import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "title truncate" }
const _hoisted_4 = { class: "description truncate" }
const _hoisted_5 = { class: "badge-wrapper" }

import { computed } from "vue";
import { IonCard, IonCardHeader, IonIcon, IonBadge } from "@ionic/vue";
import { checkmarkCircleOutline } from "ionicons/icons";
import { parseImageUrl, mapResourceType } from "@/helpers";
import { Resource } from "@/store";

interface Props {
  document: Resource;
  completed: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ResourceCard',
  props: {
    document: {},
    completed: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const featureImage = computed(() => {
  return props.document.feature_image
    ? (parseImageUrl(props.document.feature_image, 600, 600) as string)
    : "https://cdn.sanity.io/images/2i80ck01/~production/8135cdce59aec36c855d65c473f944f115bca081-4032x3024.jpg?auto=format&fit=max&w=500";
});

const description = computed(() => {
  return props.document.description
    ? props.document.description
    : "Description here";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), null, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: featureImage.value,
        alt: ""
      }, null, 8, _hoisted_1),
      _createVNode(_unref(IonCardHeader), null, {
        default: _withCtx(() => [
          (__props.completed)
            ? (_openBlock(), _createBlock(_unref(IonBadge), {
                key: 0,
                class: "status-badge complete-label",
                "data-test": "completion-badge"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(checkmarkCircleOutline),
                    "aria-hidden": "true"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", null, [
                    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("statusLabel.completed")), 1)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_3, _toDisplayString(__props.document.title), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(description.value), 1),
          _createElementVNode("div", _hoisted_5, [
            (_unref(mapResourceType)(__props.document.resource_type))
              ? (_openBlock(), _createBlock(_unref(IonBadge), {
                  key: 0,
                  class: "type-badge",
                  color: "secondary",
                  "data-test": "badge"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(_unref(mapResourceType)(__props.document.resource_type))), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.document.time)
              ? (_openBlock(), _createBlock(_unref(IonBadge), {
                  key: 1,
                  class: "time-badge",
                  color: "secondary",
                  "data-test": "badge"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.document.time + " " + _ctx.$t("resource.readingTimeMins")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})